__turbopack_context__.v({
  "card": "styles-module__Rzg_NW__card",
  "cardActions": "styles-module__Rzg_NW__cardActions",
  "cardContent": "styles-module__Rzg_NW__cardContent",
  "cardMedia": "styles-module__Rzg_NW__cardMedia",
  "column": "styles-module__Rzg_NW__column",
  "description": "styles-module__Rzg_NW__description",
  "placeOrderButton": "styles-module__Rzg_NW__placeOrderButton",
  "row": "styles-module__Rzg_NW__row",
  "title": "styles-module__Rzg_NW__title",
  "wideOnly": "styles-module__Rzg_NW__wideOnly",
});
